import CredentialFormBase from "./credential_form_base"

export default class extends CredentialFormBase {
  static targets = ["dataCenter", "consoleLink", "otherRegion", "otherRegions"]
  static values = { defaults: Boolean }

  connect() {
    const urls = JSON.parse(this.dataCenterTarget.dataset.tokenUrls)
    const detectedRegion = Object.keys(urls).find(dc => urls[dc] === this.credentialInput("oauth_token_url").value)
    if (detectedRegion) this.selectRegion(detectedRegion)
    // Opening an edit or failed save must preserve the submitted endpoints.
    this.updateRegion(this.defaultsValue)
    this.openDialog()
  }

  selectRegion(dc) {
    const input = this.dataCenterTargets.find(el => el.value === dc)
    if (input) input.checked = true
    else if (this.hasOtherRegionTarget) {
      this.dataCenterTargets.find(el => el.value === "other").checked = true
      this.otherRegionTarget.value = dc
    }
  }

  applyDataCenter() { this.updateRegion(true, true) }

  updateRegion(setDefaults = false, overwrite = false) {
    const selected = this.dataCenterTargets.find(el => el.checked)?.value
    const other = selected === "other"
    if (this.hasOtherRegionsTarget) this.otherRegionsTarget.classList.toggle("hidden", !other)
    if (this.hasOtherRegionTarget) this.otherRegionTarget.disabled = !other
    const dc = other ? this.otherRegionTarget.value : selected
    const tokenUrl = JSON.parse(this.dataCenterTarget.dataset.tokenUrls)[dc]
    if (!tokenUrl) return

    const origin = new URL(tokenUrl).origin
    this.consoleLinkTarget.href = origin.replace("accounts.", "api-console.")
    if (!setDefaults) return
    const inputs = [
      [this.credentialInput("oauth_token_url"), tokenUrl],
      [this.credentialInput("oauth_authorize_url"), `${origin}/oauth/v2/auth`],
      [this.element.querySelector('[name="api_credential[base_uri]"]'), `https://www.zohoapis.${dc}`]
    ]
    inputs.forEach(([input, value]) => { if (overwrite || !input.value) input.value = value })
  }
}
